import { z } from 'zod';

import { FulfillmentWindowSchema } from '@occc/validation';

export enum OrderedWeekday {
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
}

export type FulfillmentWindowFormValues = {
  fulfillmentWindow: z.infer<typeof FulfillmentWindowSchema>;
};

export const validTimezones = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
];

export type ValidateTimeOrderArgs = {
  availableDailyStartingAtTime?: string | Date | null;
  availableDailyEndingAtTime?: string | Date | null;
};
